<template>
  <div class="info">
    <!-- 头像信息 -->
    <div class="info_wrap">
      <div class="head_portrait">
        <img src="../assets/images/main/tou.jpg" alt />
      </div>
      <div>
        <p class="info-name">{{userName}}</p>
      </div>
      <p class="set" @click="$router.push('/information')">
        <van-icon name="setting-o" size="20px" />
      </p>
    </div>
    <!-- 我的订单 -->
    <div class="my-order">
      <div class="title">
        <h4>我的订单</h4>
        <p @click="$router.push('/my-order')">
          查看全部
          <span class="all">
            <img src="../assets/images/right.png" alt />
          </span>
        </p>
      </div>
      <ul>
        <li v-for="(item,index) in typeList" :key="index" @click="toMyOrder(index)">
          <div class="list-img">
            <i v-if="item.count >0">{{item.count}}</i>
            <div class="type-icon">
              <img :src="item.img" alt />
            </div>
          </div>
          <p>{{item.text}}</p>
        </li>
      </ul>
    </div>
    <!-- 设置 -->
    <div class="set-up">
      <ul>
        <li v-for="(item,index) in setList" :key="index" @click="$router.push(item.pathName)">
          <div class="set-icon">
            <img :src="item.leftIcon" alt />
          </div>
          <span>{{item.text}}</span>
          <div class="right-icon">
            <img :src="item.rightIcon" alt />
          </div>
        </li>
      </ul>
    </div>
    <!-- 退出登录 -->
    <div class="clear-login">
      <button @click="loginOut">退出登录</button>
    </div>
  </div>
</template>

<script>
import { SaleOrder } from "../request/api";
export default {
  name: "Main",
  data() {
    return {
      userName: "",
      orders: {},
      setList: [
        {
          leftIcon: require("../assets/images/main/fapiao.png"),
          text: "发票设置",
          rightIcon: require("../assets/images/right.png"),
          pathName: "/invoice"
        },
        {
          leftIcon: require("../assets/images/main/address.png"),
          text: "收货地址",
          rightIcon: require("../assets/images/right.png"),
          pathName: "/address"
        },
        {
          leftIcon: require("../assets/images/main/kefu.png"),
          text: "官方客服",
          rightIcon: require("../assets/images/right.png"),
          pathName: "/customer-service"
        }
      ],
      typeList: [
        {
          img: require("../assets/images/main/daifukuan@2x.png"),
          text: "待支付",
          count: ""
        },
        {
          img: require("../assets/images/main/daifahuo@2x.png"),
          text: "待发货",
          count: ""
        },
        {
          img: require("../assets/images/main/daishouhuo@2x.png"),
          text: "待收货",
          count: ""
        },
        {
          img: require("../assets/images/main/daiziti.png"),
          text: "待自提",
          count: ""
        }
      ]
    };
  },
  created() {
    this.getUser();
    this.getSaleOrder();
  },
  methods: {
    getUser() {
      if (localStorage.getItem("userInfo") != undefined) {
        this.userName = JSON.parse(localStorage.getItem("userInfo")).memName;
      }
    },
    //获取我的订单数量
    getSaleOrder() {
      SaleOrder({}).then(res => {
        this.orders = res.data;
        let arr = [];
        for (let i in this.orders) {
          arr.push(this.orders[i]);
        }
        this.typeList[0].count = arr[1];
        this.typeList[1].count = arr[3];
        this.typeList[2].count = arr[2];
        this.typeList[3].count = arr[0];
      });
    },
    toMyOrder(index) {
      this.$router.push({
        name: "my-order",
        params: {
          index: index + 1
        }
      });
    },
    //退出登录
    loginOut() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否退出登录"
        })
        .then(() => {
          localStorage.removeItem("token");
          this.$router.push("/login");
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style lang="less" scoped>
.info {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
}
.info_wrap {
  width: 100%;
  height: 250px;
  align-items: center;
  justify-content: center;
  display: flex;
  background-image: url("../assets/images/main/header.png");
  background-size: 100%;
  position: relative;
  .head_portrait {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border: 4px solid #fff;
    overflow: hidden;
    margin-right: 40px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .info-name {
    color: #fff;
    font-size: 40px;
  }
  .set {
    position: absolute;
    right: 30px;
    top: 30px;
    color: #fff;
    font-size: 28px;
  }
}
// 我的订单
.my-order {
  width: 100%;
  background: #fff;
  margin: 20px 0;
  .title {
    height: 82px;
    line-height: 82px;
    border-bottom: 1px solid #f2f2f2;
    h4 {
      color: #333;
      font-size: 34px;
      margin-left: 30px;

      display: inline-block;
    }
    p {
      float: right;
      font-size: 26px;
      color: #999;
    }
    .all {
      width: 22px;
      height: 22px;
      margin: 0 30px 0 5px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  ul {
    display: flex;
    justify-content: space-between;
    padding: 30px 60px;
    li {
      position: relative;
      text-align: center;
      i {
        display: block;
        width: 40px;
        min-height: 40px;
        line-height: 40px;
        background: #e3393c;
        color: #fff;
        text-align: center;
        font-size: 24px;
        border-radius: 50%;
        position: absolute;
        top: -15px;
        left: 43px;
      }
      .type-icon {
        height: 45px;
        width: 50px;
        display: inline-block;
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        font-size: 28px;
        color: #4d4d4d;
        margin-top: 10px;
      }
    }
  }
}
// 设置
.set-up {
  ul {
    li {
      width: 100%;
      height: 108px;
      line-height: 108px;
      border-bottom: 1px solid #f3f3f3;
      background: #fff;
      .set-icon {
        width: 35px;
        height: 37px;
        margin: 0 30px;
        vertical-align: -8px;
        display: inline-block;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right-icon {
        float: right;
        height: 21px;
        width: 25px;
        margin-right: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      span {
        color: #3b3b3b;
        font-size: 28px;
      }
    }
  }
}
.clear-login {
  padding-bottom: 150px;
  button {
    width: 690px;
    height: 96px;
    border-radius: 10px;
    background: #ff9900;
    color: #fff;
    font-size: 36px;
    border: none;
    margin: 50px 0 0 30px;
  }
}
</style>